import DialogView from 'dialogview';
import scriptjs from 'scriptjs';

import style     from 'stripe-card-dialog.scss';

// Pulled from sniffing around in stripe checkout js
const countriesShowingZipAfterCity = ["AU", "BR", "CA", "CN", "HU", "IN", "ID", "IE", "IL", "JP", "NZ", "PK", "PE", "RU", "SA", "SG", "TH", "UA", "GB", "US"];
const ziplessCountries = ["AE", "AG", "AO", "AW", "BF", "BI", "BJ", "BO", "BS", "BW", "BZ", "CD", "CF", "CG", "CI", "CK", "CM", "DJ", "DM", "ER", "FJ", "GD", "GH", "GM", "GN", "GQ", "GY", "HK", "IE", "JM", "KE", "KI", "KM", "KN", "KP", "LC", "ML", "MO", "MR", "MS", "MU", "MW", "NR", "NU", "PA", "QA", "RW", "SA", "SB", "SC", "SL", "SO", "SR", "ST", "SY", "TF", "TK", "TL", "TO", "TT", "TV", "TZ", "UG", "VU", "YE", "ZA", "ZW"];

export default DialogView.extend({
    el: '#cardPayment',
    hideInstant: true,
    initialize: function (options) {
        DialogView.prototype.initialize.call(this, options);

        this.cardholder = this.$('#cardPayment__cardholder');

        this.cardLine1 = this.$('#cardPayment__line1');
        this.cardLine2 = this.$('#cardPayment__line2');
        this.cardState = this.$('#cardPayment__state');
        this.cardCityZip = this.$('#cardPayment__cityZip');
        this.cardCountry = this.$('#cardPayment__country');

        this.submit = this.$('#cardPayment__submit');
        this.cardEl = this.$('#cardPayment__card');
        this.cardLoading = this.$('.cardPayment__cardLoading');
        this.cardError = this.$('.cardPayment__error');
        this.cardInputError = this.$('.cardPayment__input-error');
        this.cardDescription = this.$('.cardPayment__description');
        this.cardAmountHead = this.$('.cardPayment__amountHead');
        this.cardAmount = this.$('.cardPayment__amount');
        this.stripeError = this.$('.stripeError');
    },

    loadStripe: function () {
        if (this._loadStripeCalled) {
            return;
        }
        this._loadStripeCalled = true;
        scriptjs([
            "https://js.stripe.com/v3/"
        ], _.bind(function () {
            if (window.Stripe) {
                this.Stripe = window.Stripe(
                    window.IRCConfig.StripeCheckoutOptions.key
                );
                scriptjs.done('stripe');
            } else {
                this.showStripeError();
            }
        }, this));
    },
    showStripeError: function () {
        this.stripeError.show();
    },
    events: $.extend({}, DialogView.prototype.events, {
        'buttonClick #cardPayment__submit': 'onSubmit',
        'buttonClick .upgradePayment__confirm-country-button': 'onConfirmCountry',
        'change #cardPayment__country': 'onCountryChange',
        'change #cardPayment__zip': 'onZipChange'
    }),
    reset: function () {
        this.model = null;
        this.parent = null;
        this.values = {};
        this.callback = null;
        this.confirmedCountry = null;

        this.resetStripe();
        this.disableForm();
        this.hideError();

        this.cardholder.val('');

        this.cardLine1.val('');
        this.cardLine2.val('');
        this.cardState.val('');
        this.cardCityZip.html('');
        this.cardCity = null;
        this.cardZip = null;
        this.cardCountry.html('');

        this.cardAmount.text('');
        this.cardAmountHead.hide();
        this.cardDescription.text('');
        this.submit.find('span').text('');
        this.cardEl.val('');
        this.submit.removeSpin();
    },
    isDisabled: function () {
        return this.disabled;
    },
    disableForm: function () {
        if (!this.isDisabled()) {
            this.disabled = true;
            this.submit.prop('disabled', true);
        }
    },
    enableForm: function () {
        if (this.isDisabled()) {
            this.disabled = false;
            this.submit.prop('disabled', false);
        }
    },
    resetStripe: function () {
        if (this.cardElement) {
            this.cardElement.destroy();
            this.cardElement = null;
        }
    },
    renderName: function () {
        this.cardholder.val(this.model.session.get('name'));
    },
    getZip: function () {
        if (this.cardZip) {
            return this.cardZip.val();
        }
    },
    getCountry: function () {
        return this.cardCountry.val();
    },
    renderCityZip: function () {
        var city = this.cardCity ? this.cardCity.val() : null;
        var zip = this.cardZip ? this.cardZip.val() : null;
        var country = this.getCountry();

        this.cardCity = $('<input id="cardPayment__city" type="text" class="input" placeholder="City">');
        if (city) {
            this.cardCity.val(city);
        }
        var label = country === "US" ? "Zip" : "Postcode";
        this.cardZip = $('<input id="cardPayment__zip" type="text" class="input">').attr('placeholder', label);
        if (zip) {
            this.cardZip.val(zip);
        }

        this.cardCityZip.html('');
        if (_.includes(ziplessCountries, country)) {
            this.cardCityZip.append(this.cardCity);
        } else if (!country || _.includes(countriesShowingZipAfterCity, country)) {
            this.cardCityZip.append(this.cardCity);
            this.cardCityZip.append(this.cardZip);
        } else {
            this.cardCityZip.append(this.cardZip);
            this.cardCityZip.append(this.cardCity);
        }
    },
    renderCountries: function () {
        this.cardCountry.html('<option>');
        var plans = this.model.session.plans;
        _.each(plans.countries, _.bind(function (name, code) {
            var option = $('<option>').val(code).text(name);
            if (code === (plans.vat_country || plans.country)) {
                option.prop('selected', true);
            }
            this.cardCountry.append(option);
        }, this));
    },
    renderStripe: function (callback) {
        var elements = this.Stripe.elements();
        this.cardElement = elements.create('card', {
            hidePostalCode: true
        });
        this.cardElement.mount(this.cardEl[0]);
        this.cardElement.on('change', _.bind(function (e) {
            if (e.error) {
                this.showInputError(e.error.message);
            } else {
                this.hideInputError();
            }
        }, this));
        this.cardElement.on('ready', _.bind(function (e) {
            callback();
        }, this));
    },

    afterHide: function () {
        this.callback();
        this.reset();
    },
    showError: function (response) {
        this.cardError.html(this.parent.formatStripeError(response)).show();
        this.enableForm();
        this.submit.removeSpin();
    },
    hideError: function () {
        this.cardError.hide().html('');
        this.hideInputError();
    },
    showInputError: function (message) {
        this.cardInputError.text(message).show();
    },
    hideInputError: function () {
        this.cardInputError.hide().text('');
    },
    renderLabel: function (label) {
        this.submit.find('span').text(label);
    },
    renderValues: function () {
        this.cardDescription.text(this.values.description);
        if (this.values.amount) {
            this.cardAmount.text(
                this.parent.formatter.amount(this.values.currency, this.values.amount)
            );
            this.cardAmountHead.show();
        }
    },
    show: function (options) {
        this.model = options.model;
        this.parent = options.parent;

        this.renderName();
        this.renderCountries();
        this.renderCityZip();

        this.callback = options.callback;
        this.values = options.values;

        this.renderValues();
        this.renderLabel(options.label);

        this.cardLoading.show();
        this.disableForm();

        this.loadStripe();

        scriptjs.ready('stripe', _.bind(function () {
            this.renderStripe(_.bind(function () {
                this.cardLoading.hide();
                this.enableForm();
            }, this));
        }, this));

        return DialogView.prototype.show.call(this);
    },
    onCountryChange: function (e) {
        this.renderCityZip();
    },
    onZipChange: function (e) {
        if (this.cardElement) {
            this.cardElement.update({value: {postalCode: this.getZip()}});
        }
    },

    getPaymentMethodData: function () {
        return {
            billing_details: {
                name: this.cardholder.val(),
                email: this.values.email,
                address: {
                    city: this.cardCity.val(),
                    country: this.getCountry(),
                    line1: this.cardLine1.val(),
                    line2: this.cardLine2.val(),
                    postal_code: this.cardZip.val(),
                    state: this.cardState.val()
                }
            }
        };
    },

    createPaymentMethod: function () {
        this.Stripe.createPaymentMethod(
            'card', this.cardElement, this.getPaymentMethodData()
        ).then(_.bind(this.handlePaymentMethod, this));
    },

    onConfirmCountry: function (e) {
        this.confirmedCountry = $(e.target).data('country');
        this.onSubmit(e);
    },
    onSubmit: function (e) {
        e.preventDefault();
        if (this.isDisabled()) {
            return;
        }

        this.submit.addSpin();
        this.disableForm();
        this.hideError();

        this.createPaymentMethod();
    },
    handlePaymentMethod: function (stripeMethod) {
        debug.info('<- [STRIPE paymentMethod]', stripeMethod);

        if (stripeMethod.error) {
            return this.showError({
                success: false,
                message: 'card_error',
                data: stripeMethod.error
            });
        }

        this.callback({
            stripe_method: stripeMethod.paymentMethod.id,
            country: this.confirmedCountry
        }, _.bind(this.handlePaymentCallbackResponse, this));
    },
    done: function (response) {
        if (
            response.customer &&
            (response.delinquent || (
                !response.initial && response.subscription == 'incomplete'
            ))
        ) {
            this.model.payDelinquentStripeInvoice({
                customer_id: response.customer,
                org: this.values.org
            });
        }
        var parent = this.parent;
        this.hide();
        parent.afterPay(response);
    },
    handlePaymentCallbackResponse: function (callbackResponse) {
        debug.info('<- [STRIPE paymentCallbackResponse]', callbackResponse);

        if (!callbackResponse.success) {
            return this.showError(callbackResponse);
        }
        if (
            callbackResponse.intent_status !== 'requires_action' &&
            callbackResponse.intent_status !== 'requires_source_action'
        ) {
            // No further action necessary, payment confirmed
            this.done(callbackResponse);
        } else {
            var stripeFun = (callbackResponse.intent_type == 'setup_intent') ? 
                'handleCardSetup' : 'handleCardPayment';
            this.Stripe[stripeFun](
                callbackResponse.intent_client_secret
            ).then(_.bind(this.handlePaymentIntent, this, stripeFun, callbackResponse));
        }
    },
    handlePaymentIntent: function (stripeFun, callbackResponse, stripeIntent) {
        debug.info('<- [STRIPE stripeIntent: ' + stripeFun + ']', stripeIntent, callbackResponse);

        if (stripeIntent.error) {
            if (callbackResponse.customer && callbackResponse.initial) {
                this.model.cancelIncompleteStripeSubscription({
                    customer_id: callbackResponse.customer,
                    org: this.values.org
                });
            }
            return this.showError({
                success: false,
                message: 'card_error',
                data: stripeIntent.error
            });
        }
        // Payment confirmed
        this.done(callbackResponse);
    }
});


// WEBPACK FOOTER //
// ./app/src/view/stripe-card-dialog-view.es6